import React from 'react';
import { Check } from 'lucide-react';

const StepIndicator = ({ steps, currentStep }) => {
    return (
        <div className="w-full">
            <div className="flex items-center justify-between">
                {steps.map((step, index) => (
                    <React.Fragment key={step.id}>
                        {/* Step Circle */}
                        <div className="flex flex-col items-center flex-1">
                            <div
                                className={`
                  w-12 h-12 rounded-full flex items-center justify-center border-2 transition-all duration-300
                  ${currentStep === index
                                        ? 'border-blue-600 bg-blue-600 text-white shadow-lg shadow-blue-200'
                                        : currentStep > index
                                            ? 'border-green-500 bg-green-500 text-white'
                                            : 'border-gray-300 bg-white text-gray-400'
                                    }
                `}
                            >
                                {currentStep > index ? (
                                    <Check className="w-6 h-6" />
                                ) : (
                                    <span className="text-lg font-semibold">{step.id}</span>
                                )}
                            </div>

                            {/* Step Text */}
                            <div className="mt-3 text-center">
                                <p
                                    className={`text-sm font-medium ${currentStep >= index ? 'text-gray-900' : 'text-gray-500'
                                        }`}
                                >
                                    {step.title}
                                </p>
                                <p className="text-xs text-gray-500 mt-1 hidden sm:block">
                                    {step.description}
                                </p>
                            </div>
                        </div>

                        {/* Connector Line */}
                        {index < steps.length - 1 && (
                            <div
                                className={`
                  h-0.5 flex-1 mx-2 -mt-16 transition-all duration-300
                  ${currentStep > index ? 'bg-green-500' : 'bg-gray-300'}
                `}
                            />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default StepIndicator;